<script setup lang="ts">
import { computed } from 'vue';

import EvaluationFilterChips from '@/components/playbooks/EvaluationFilterChips.vue';
import {
  showGroupFilterRow,
  showTypeFilterRow,
  type EvaluationFilterBucket,
} from '@/composables/usePlaybookRunCells';

const props = defineProps<{
  typeBuckets: EvaluationFilterBucket[];
  groupBuckets: EvaluationFilterBucket[];
  /** Evaluation columns in total, and how many survive the current filters. */
  total: number;
  shown: number;
}>();

const selectedTypes = defineModel<string[]>('types', { required: true });
const selectedGroups = defineModel<string[]>('groups', { required: true });

const showTypes = computed<boolean>(() => showTypeFilterRow(props.typeBuckets));
const showGroups = computed<boolean>(() => showGroupFilterRow(props.groupBuckets));

const summary = computed<string>(() =>
  props.shown === props.total
    ? `Showing all ${props.total} evaluations`
    : `Showing ${props.shown} of ${props.total} evaluations`
);
</script>

<template>
  <div class="column-filters">
    <EvaluationFilterChips
      v-if="showTypes"
      v-model="selectedTypes"
      label="Evaluation type"
      :buckets="typeBuckets"
    />

    <EvaluationFilterChips
      v-if="showGroups"
      v-model="selectedGroups"
      label="Evaluation group"
      :buckets="groupBuckets"
    />

    <n-text :depth="3" class="summary">{{ summary }}</n-text>
  </div>
</template>

<style scoped>
.column-filters {
  display: grid;
  /* The label column sizes to the widest label, so both rows' chips line up. */
  grid-template-columns: auto 1fr;
  align-items: center;
  gap: 6px 8px;
}

/* Its own row under the last filter, starting where the chips start. */
.summary {
  grid-column: 2;
  font-size: 13px;
}
</style>
